<div class="turn-page">
  <i class="icon-horizontal"></i>
  <div class="turn-message">
    <div>מה המצב?</div>
    <div>נראה לנו שבטעות סובבתם את המכשיר הנייד למצב שוכב.</div>
    <div>בבקשה סובבו בחזרה למצב עומד בכדי שנמשיך.</div>
  </div>
</div>
